import React from "react";

import DatePicker from "react-datepicker";
import styled from "styled-components";
import { FieldProps } from "formik";
import { get } from "../utils/get";

const CustomInput = ({ placeholder, value, ...props }: any) => {
  return (
    <InputContainer>
      <DatePickerInput value={value} placeholder={placeholder} {...props} />
    </InputContainer>
  );
};

const DateRange = ({
  label,
  isClearable,
  field: { value, name },
  form: { setFieldValue },
}: { label?: string; isClearable?: boolean } & FieldProps) => {
  return (
    <Container isLabelled={!!label}>
      {label && <DateLabel>{label}</DateLabel>}
      <DateRangeContainer>
        <DatePicker
          isClearable={isClearable}
          selected={get(value, "startDate")}
          onChange={(date: any) =>
            setFieldValue(name, { ...value, startDate: date })
          }
          selectsStart
          dateFormat="dd-MMMM-yyyy"
          customInput={
            <CustomInput
              value={get(value, "startDate")}
              placeholder="Start date.."
            />
          }
          startDate={get(value, "startDate")}
          endDate={get(value, "endDate")}
        />
        <Devider>-</Devider>
        <DatePicker
          isClearable={isClearable}
          selected={get(value, "endDate")}
          dateFormat="dd-MMMM-yyyy"
          onChange={(date: any) =>
            setFieldValue(name, { ...value, endDate: date })
          }
          selectsEnd
          customInput={
            <CustomInput
              value={get(value, "endDate")}
              placeholder="End date.."
            />
          }
          startDate={get(value, "startDate")}
          endDate={get(value, "endDate")}
          minDate={get(value, "startDate")}
        />
      </DateRangeContainer>
    </Container>
  );
};

export default DateRange;

const Container = styled.div<{ isLabelled: boolean }>`
  display: grid;
  grid-template-rows: ${(props) => props.isLabelled && "1.5em auto"};
`;

const DateRangeContainer = styled.div`
  display: flex;
  align-items: center;
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
`;

const DatePickerInput = styled.input`
  padding: 1em 1em;
  padding-left: 2em;
  margin: 0.5em 1em;
  font-weight: normal;
  font-size: 12px;
  background-color: #fff;
  font-weight: bold;
  color: #214160;
  box-shadow: none;
  width: 60%;
  text-align: center;
  border: 1px solid rgba(33, 65, 96, 0.6);
  border-radius: 0.5em;
  display: flex;
  align-items: center;
  ::placeholder {
    color: #999;
    font-size: 0.9rem;
  }
`;

const Devider = styled.span`
  text-align: center;
  align-self: center;
  font-weight: 500;
`;

const Icon = styled.span`
  position: absolute;
  bottom: 2px;
  left: 6px;
  width: 27px;
  height: 27px;
`;

const DateLabel = styled.label`
  color: rgba(33, 65, 96, 0.4);
  font-size: 0.75em;
`;
